import { render, staticRenderFns } from "./LocationGuides.vue?vue&type=template&id=5827367c&scoped=true"
import script from "./LocationGuides.vue?vue&type=script&lang=js"
export * from "./LocationGuides.vue?vue&type=script&lang=js"
import style0 from "./LocationGuides.vue?vue&type=style&index=0&id=5827367c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5827367c",
  null
  
)

export default component.exports